module.exports = __webpack_public_path__ + "static/media/Lock.bc4ca4d8.svg";